import React from 'react';
import './AgentActivity.css';

// "פעילות הסוכן" — a chronological LOG of what the agent actually did, not a
// fixed checklist. Each entry is { id, time, text, kind }; kind drives the icon.
const KIND_META = {
  done: { icon: 'fi-rr-check', cls: 'is-done' },
  info: { icon: 'fi-rr-info', cls: 'is-info' },
  warn: { icon: 'fi-rr-exclamation', cls: 'is-warn' },
  error: { icon: 'fi-rr-cross-circle', cls: 'is-error' },
  running: { icon: 'fi-rr-spinner', cls: 'is-running' },
};

export default function AgentActivity({ log, loading }) {
  const events = log || [];
  return (
    <section className="ag-card">
      <header className="ag-head">
        <i className="fi fi-rr-bolt" />
        <h3>פעילות הסוכן</h3>
      </header>
      {events.length === 0 ? (
        <div className="ag-empty">
          {loading
            ? <><span className="rp-spinner" /> אוסף נתונים על הנכס…</>
            : 'טרם בוצעו פעולות.'}
        </div>
      ) : (
        <ol className="ag-list">
          {events.map((e) => {
            const meta = KIND_META[e.kind] || KIND_META.info;
            return (
              <li key={e.id} className={`ag-item ${meta.cls}`}>
                <span className="ag-ic">
                  {e.kind === 'running' ? <span className="rp-spinner" /> : <i className={`fi ${meta.icon}`} />}
                </span>
                <span className="ag-body">
                  <span className="ag-text">{e.text}</span>
                  {e.time && <span className="ag-time">{e.time}</span>}
                </span>
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
}
